<template>
  <div>
    <CCard>
      <CCardHeader>
        Router List
      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol sm="12">
            <CDataTable
              hover
              small
              fixed
              table-filter
              sorter
              items-per-page-select
              :items-per-page="15"
              :fields="routerListFields"
              :items="routerListItem"
              :noItemsView="{ noItems: 'No Item~' }"
              pagination
            >
              <template #status="{item}">
                <td class="py-2">
                  <CBadge :color="item.status === 1 ? 'success' : item.status === 2 ? 'danger' : 'secondary'">
                    {{ item.status === 1 ? 'Online' : item.status === 2 ? 'Offline' : 'Unknown' }}
                  </CBadge>
                </td>
              </template>
              <template #uptime="{item}">
                <td class="py-2">
                  <span v-if="item.status === 1">{{ item.uptime }}</span>
                  <span v-else-if="item.last_online_at">
                    <small class="text-muted">Last online: {{ item.last_online_at | dateFormat }}</small>
                  </span>
                  <span v-else class="text-muted">-</span>
                </td>
              </template>
              <template #action="{item}">
                <td class="py-2">
                  <CButtonGroup>
                    <CButton
                      color="primary"
                      square
                      @click="$router.push('/router/view/'+item.id)"
                    >
                      View
                    </CButton>
                    <CButton
                      color="info"
                      square
                      @click="openRenameModal(item)"
                    >
                      Rename
                    </CButton>
                    <CButton
                      color="danger"
                      square
                      @click="deleteRouter(item.id)"
                    >
                      Delete
                    </CButton>

                  </CButtonGroup>
                </td>
              </template>
            </CDataTable>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>

    <CCard>
      <CCardHeader>
        Authed Router List
      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol sm="12">
            <CDataTable
              hover
              small
              fixed
              table-filter
              sorter
              items-per-page-select
              :items-per-page="15"
              :fields="authedRouterListFields"
              :items="authedRouterListItem"
              :noItemsView="{ noItems: 'No Item~' }"
              pagination
            >
              <template #status="{item}">
                <td class="py-2">
                  <CBadge :color="item.status === 1 ? 'success' : item.status === 2 ? 'danger' : 'secondary'">
                    {{ item.status === 1 ? 'Online' : item.status === 2 ? 'Offline' : 'Unknown' }}
                  </CBadge>
                </td>
              </template>
              <template #uptime="{item}">
                <td class="py-2">
                  <span v-if="item.status === 1">{{ item.uptime }}</span>
                  <span v-else-if="item.last_online_at">
                    <small class="text-muted">Last online: {{ item.last_online_at | dateFormat }}</small>
                  </span>
                  <span v-else class="text-muted">-</span>
                </td>
              </template>
              <template #action="{item}">
                <td class="py-2">
                  <CButtonGroup>
                    <CButton
                      color="danger"
                      square
                      @click="deleteRouterAuth(item.record_id)"
                    >
                      Remove Authorization
                    </CButton>

                  </CButtonGroup>
                </td>
              </template>
            </CDataTable>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>

    <CToaster :autohide="3000">
      <template v-for="toast in fixedToasts">
        <CToast
          :key="'toast' + toast"
          :show="true"
          :color="alertLevel"
          header="Alert"
        >
          {{ returnMsg }}
        </CToast>
      </template>
    </CToaster>
    <CModal
      title="Request Message"
      color="primary"
      :show.sync="requestMsgModal"
    >
      {{ requestMsg }}
      <template #footer>
        <CButton @click="requestMsgModal=false" color="primary">Close</CButton>
      </template>
    </CModal>

    <!-- 重命名 Modal -->
    <CModal
      :show.sync="renameModal.show"
      :title="'Rename Router - ' + (renameModal.item ? renameModal.item.name : '')"
      color="info"
    >
      <CForm>
        <RouterNameBuilder v-model="renameModal.name" @role-change="v => renameModal.router_role = v" />
      </CForm>
      <template #footer>
        <CButtonGroup>
          <CButton color="secondary" @click="renameModal.show = false">取消</CButton>
          <CButton color="success" :disabled="renameModal.loading" @click="submitRename">{{ renameModal.loading ? '保存中...' : '保存' }}</CButton>
        </CButtonGroup>
      </template>
    </CModal>
  </div>
</template>

<script>
import RouterNameBuilder from '@/components/RouterNameBuilder'

export default {
  name: "List",
  components: { RouterNameBuilder },
  data() {
    const routerListFields = [
      { key: "id", label: "ID" },
      { key: "name", label: "Name" },
      { key: "router_role", label: "Role" },
      { key: "dns_name", label: "Host" },
      { key: "status", label: "Status" },
      { key: "version", label: "Version" },
      { key: "uptime", label: "Uptime" },
      { key: "location", label: "Location" },
      { key: "isp", label: "ISP" },
      {
        key: "action",
        label: "Action",
        sorter: false,
        filter: false,
        _style: "width: 10%"
      }
    ];

    const authedRouterListFields = [
      { key: "id", label: "ID" },
      { key: "auth_user", label: "Authed To" },
      { key: "name", label: "Name" },
      { key: "dns_name", label: "Host" },
      { key: "status", label: "Status" },
      { key: "version", label: "Version" },
      { key: "uptime", label: "Uptime" },
      { key: "location", label: "Location" },
      { key: "isp", label: "ISP" },
      {
        key: "action",
        label: "Action",
        sorter: false,
        filter: false,
        _style: "width: 10%"
      }
    ];

    return {
      fixedToasts: 0,
      returnMsg: "",
      alertLevel: "success",
      requestMsgModal: false,
      requestMsg: null,
      routerListFields,
      routerListItem: [],
      authedRouterListFields,
      authedRouterListItem:[],
      renameModal: {
        show: false,
        loading: false,
        item: null,
        name: '',
        router_role: ''
      }
    };
  },
  mounted: function() {
    this.onLoadPage();
  },
  methods: {
    onLoadPage: function() {
      this.$axios.get("user/router", {})
        .then((response) => {
          if (response.data.code === 200) {
            this.routerListItem = response.data.userRouter.map(item => {
              return {
                ...item
              }
            });
            this.authedRouterListItem = response.data.authedRouter.map(item => {
              return {
                ...item.router,
                auth_user: item.auth_user ? item.auth_user.mail : '',
                record_id: item.id
              }
            });
          }
        });
    },
    deleteRouterAuth: function(id) {
      this.$axios.delete("user/router/auth/"+id+"/delete", {})
        .then((response) => {
          this.requestMsg = response.data.msg;
          this.requestMsgModal = true;
          this.onLoadPage();
        });
    },
    deleteRouter: function(id) {
      this.$axios.delete("user/router/"+id+"/delete", {})
        .then((response) => {
          this.requestMsg = response.data.msg;
          this.requestMsgModal = true;
          this.onLoadPage();
        });
    },
    openRenameModal(item) {
      this.renameModal.item = item;
      this.renameModal.name = item.name || '';
      this.renameModal.router_role = item.router_role || '';
      this.renameModal.show = true;
    },
    submitRename() {
      if (!this.renameModal.item || !this.renameModal.name) {
        this.returnMsg = "名称不能为空";
        this.alertLevel = "danger";
        this.fixedToasts++;
        return;
      }
      this.renameModal.loading = true;
      this.$axios.post("user/router/" + this.renameModal.item.id + "/rename", {
        name: this.renameModal.name,
        router_role: this.renameModal.router_role
      })
        .then((response) => {
          if (response.data.code === 200) {
            this.returnMsg = response.data.msg;
            this.alertLevel = "success";
            this.fixedToasts++;
            this.renameModal.show = false;
            this.onLoadPage();
          } else {
            this.returnMsg = response.data.msg;
            this.alertLevel = "danger";
            this.fixedToasts++;
          }
          this.renameModal.loading = false;
        })
        .catch((e) => {
          this.returnMsg = "网络错误: " + e.message;
          this.alertLevel = "danger";
          this.fixedToasts++;
          this.renameModal.loading = false;
        });
    },
  }
};
</script>